import React from 'react';
import Et0Chart from '../../../components/Highcharts/Et0Chart/Et0Chart';
import RadiationChart from '../../../components/Highcharts/LineCharts/RadiationChart/RadiationChart';
import WindChart from '../../../components/Highcharts/LineCharts/WindChart/WindChart';
import DpvChart from '../../../components/Highcharts/LineCharts/DpvChart/DpvChart';
import HumidityTemperatureChart from '../../../components/Highcharts/LineCharts/HumidityTemperatureChart/HumidityTemperatureChart';
import RainfallChart from '../../../components/Highcharts/RainfallChart/RainfallChart';
import useStyles from '../../../components/Highcharts/styles';
import useResponsiveChartHeight from '../../../hooks/useResponsiveChartHeight';
import DegreeDayChart from '../../../components/Highcharts/DegreeDayChart/DegreeDayChart';
import ColdHoursChart from '../../../components/Highcharts/LineCharts/ColdHoursChart/ColdHoursChart';
import { DEFAULT_COLD_HOURS_CONFIG } from '../../../components/Highcharts/LineCharts/ColdHoursChart/types';
import { CHART_TITLE_WS_GRADOS_DIA, CHART_TITLE_WS_HORAS_FRIO } from '../../../constants/graphs';

function WeatherStationDashboard({
  sectorId,
  farmId,
}: {
  sectorId: string,
  farmId: string,
}) {
  const classes = useStyles();
  const { smallChartHeight } = useResponsiveChartHeight();

  return (
    <div className={classes.dashboardContainer}>
      <Et0Chart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="ETo"
        isWeatherStation={true}
      />
      <RainfallChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Precipitaciones"
        isWeatherStation={true}
      />
      <RadiationChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Radiación solar"
        isWeatherStation={true}
      />
      <WindChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        yAxisTitle=""
        isWeatherStation={true}
      />
      <DpvChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        yAxisTitle=""
        isWeatherStation={true}
      />
      <HumidityTemperatureChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        yAxisTitle=""
        isWeatherStation={true}
      />
      <DegreeDayChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        title={CHART_TITLE_WS_GRADOS_DIA}
        farmId={farmId}
        yAxisTitle=""
        isWeatherStation={true}
      />
      <ColdHoursChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        title={CHART_TITLE_WS_HORAS_FRIO}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        config={DEFAULT_COLD_HOURS_CONFIG}
        yAxisTitle=""
        isWeatherStation={true}
      />
    </div>
  );
}

export default WeatherStationDashboard;
